import { createTranslator } from '@gandi/react-translate';
import { localePath } from '../services/url';
import { fetchTranslations } from '../services/locale';

import { DEFAULT_LOCALE, SITEACCESS } from '../settings/locale';
const translations = require(`../../public/assets/locales/${DEFAULT_LOCALE}/translations.json`);

let countryCode, language;
const locale = localePath || DEFAULT_LOCALE;
if (locale) {
  const split = locale.split('_');
  language = split[0].toLowerCase();
  countryCode = split[1].toUpperCase();
}

const translatorParams = {
  translations,
  locale,
  DEFAULT_LOCALE
};
const translator = createTranslator(translatorParams);

fetchTranslations(locale)
  .catch(() => fetchTranslations(DEFAULT_LOCALE))
  .then(translations => translator.translator.registerTranslations(locale, translations));

const store = SITEACCESS[locale] || 'default';

export default translator;
export { locale, language, countryCode, store };



// WEBPACK FOOTER //
// ./src/services/translator.js